var _defs, _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGebeyaBasketLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "basketGrad",
    x1: 12,
    y1: 14,
    x2: 58,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0891B2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 28C20 19.1634 27.1634 12 36 12C44.8366 12 52 19.1634 52 28",
    stroke: "url(#basketGrad)",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28H58L53.5 57C53.2 59 51.4 60.5 49.4 60.5H22.6C20.6 60.5 18.8 59 18.5 57L14 28Z",
    fill: "#E2E8F0",
    stroke: "#0F172A",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 39H48",
    stroke: "#0F172A",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 47H50",
    stroke: "#0F172A",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 17.5,
    r: 5.5,
    fill: "#22D3EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 14.7V20.3M48.7 17.5H54.3",
    stroke: "#0F172A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGebeyaBasketLogo);
export default __webpack_public_path__ + "static/media/gebeya-basket-logo.c0f16ca890c20fc4459fcb10fd72c9ec.svg";
export { ForwardRef as ReactComponent };